export default __webpack_public_path__ + "static/media/AneomiClosed4.76351edc.jpg";